import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { sendPageViewEvent } from "@insite/client-framework/OdpEvents/PageViewEvent";
import PageProps from "@insite/client-framework/Types/PageProps";

type HandlerType = Handler<{ page: PageProps }>;

export const SendPageView: HandlerType = props => {
    // the cart page view event is split apart because it requires cartLines being loaded and they aren't always loaded here
    if (props.parameter.page.type === "CartPage") {
        return;
    }

    sendPageViewEvent(props.parameter.page, props.getState());
};

export const chain = [SendPageView];

const sendPageView = createHandlerChainRunner(chain, "SendPageView");
export default sendPageView;
